import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import '../../../styles/returns.scss';
var QRCode = function (_a) {
    var sorisId = _a.sorisId, imageSrc = _a.imageSrc;
    return (React.createElement("div", { className: "sui-m-auto sui-mb-6 qr-code" },
        React.createElement("div", { className: "sui-mb-4" },
            React.createElement("img", { src: imageSrc, height: 233, width: 233, alt: "QR Code" })),
        React.createElement("div", { className: "sui-flex sui-justify-center" },
            React.createElement(Typography, { variant: "body-xs" },
                "Return ID: ",
                sorisId))));
};
export default QRCode;
